import { List } from 'immutable';
import { bulk as bulkSelections } from '../../selections/actions/update';
import addError from '../../../utils/error.jsx';

export function request(eventId, marketId, data) {
    return {
        type: 'MARKETS_ADD_RULE4_REQUEST',
        eventId,
        marketId,
        data
    };
}

export function error(marketId, errors) {
    addError(errors);

    return {
        type: 'MARKETS_ADD_RULE4_ERROR',
        errors,
        marketId
    };
}

export function finish(marketId, market) {
    return (dispatch) => {
        dispatch(bulkSelections(market.selections));

        market.selections = market.selections.map(x => x.id);

        dispatch({
            type: 'MARKETS_ADD_RULE4_FINISH',
            market,
            marketId
        });
    };
}
